var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewPublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8181 0.183853L14.8339 0.199591C14.8827 0.254304 14.9163 0.321111 14.931 0.393268C14.9473 0.47297 14.9397 0.555685 14.9093 0.63114V0.631267L9.35097 14.5266C9.30626 14.6383 9.2316 14.7355 9.13521 14.8075C9.03882 14.8795 8.92444 14.9235 8.80464 14.9347C8.68485 14.9458 8.5643 14.9238 8.45625 14.8708C8.34821 14.8179 8.25686 14.7362 8.19226 14.6347L5.15663 9.86348L5.14917 9.85176L5.13744 9.8443L0.366203 6.80866L0.366132 6.80862C0.264401 6.74408 0.182474 6.6527 0.129393 6.54455C0.0763123 6.4364 0.0541403 6.31569 0.0653239 6.19574C0.0765075 6.07578 0.120612 5.96125 0.19277 5.86478C0.264929 5.76831 0.362336 5.69364 0.474244 5.64903L0.474304 5.649L14.3696 0.0925851L14.3698 0.092531C14.4452 0.0621558 14.528 0.0546178 14.6077 0.0708534C14.6874 0.087089 14.7605 0.126383 14.8181 0.183853ZM6.01299 9.57391L5.97754 9.60937L6.00446 9.65167L8.64178 13.7953L8.70725 13.8982L8.75253 13.785L13.2735 2.48303L13.1713 2.41562L6.01299 9.57391ZM12.5402 1.72199H12.5281L12.5169 1.72646L1.21497 6.24743L1.10173 6.29274L1.20464 6.3582L5.34927 8.99456L5.39156 9.02146L5.427 8.98602L12.5853 1.82868L12.692 1.72199H12.5411H12.5402Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPublish);
export default __webpack_public_path__ + "static/media/new-publish.9f016385a13bb15b357b916a22dae24e.svg";
export { ForwardRef as ReactComponent };